<style scope>
</style>

<template>
  <section class="container">

    <portal-box style="min-height: 600px">
      <h1 slot="titulo" class="title">
        <b-field>
          <b-radio-button v-model="tipoSelecionado"
                          native-value="clienteAtivo"
                          type="is-primary">
            <span>Cliente Ativo</span>
          </b-radio-button>

          <b-radio-button v-model="tipoSelecionado"
                          native-value="clienteInativo"
                          type="is-primary">
            <span>Cliente Inativo</span>
          </b-radio-button>

          <b-radio-button v-model="tipoSelecionado"
                          native-value="clienteTendenciaInatividade"
                          type="is-primary">
            <span>Com Tendência a Inatividade</span>
          </b-radio-button>

          <b-radio-button v-model="tipoSelecionado"
                          native-value="prospecto"
                          type="is-primary">
            <span>Prospect</span>
          </b-radio-button>

        </b-field>
      </h1>

       <!-- Filtro de Busca - CLIENTE ATIVO -->
      <template v-if="tipoSelecionado === 'clienteAtivo'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="CNPJ">
            <b-input v-model="filtro.cnpj" placeholder="cnpj" v-mask="'##.###.###/####-##'"/>
          </b-field>

          <b-field label="Razão">
            <b-input v-model="filtro.razao" placeholder="razão social"/>
          </b-field>

          <b-field label="Fantasia">
            <b-input v-model="filtro.fantasia" placeholder="nome fantasia"/>
          </b-field>

          <label class="label">Primeira compra</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.primeiraCompraInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.primeiraCompraInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.primeiraCompraFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.primeiraCompraFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

          <label class="label">Última compra</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.ultimaCompraInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.ultimaCompraInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.ultimaCompraFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.ultimaCompraFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>
        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>
        <b-tag class="is-medium is-primary" style="height: 100%">Total: {{lista.length}}</b-tag>
      </template>

      <!-- Filtro de Busca - CLIENTE INATIVO -->
      <template v-if="tipoSelecionado === 'clienteInativo'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="CNPJ">
            <b-input v-model="filtro.cnpj" placeholder="cnpj" v-mask="'##.###.###/####-##'"/>
          </b-field>

          <b-field label="Razão">
            <b-input v-model="filtro.razao" placeholder="razão social"/>
          </b-field>

          <b-field label="Fantasia">
            <b-input v-model="filtro.fantasia" placeholder="nome fantasia"/>
          </b-field>

          <label class="label">Primeira compra</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.primeiraCompraInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.primeiraCompraInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.primeiraCompraFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.primeiraCompraFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

          <label class="label">Última compra</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.ultimaCompraInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.ultimaCompraInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.ultimaCompraFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.ultimaCompraFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>
        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>
        <b-tag class="is-medium is-primary" style="height: 100%">Total: {{lista.length}}</b-tag>
      </template>

      <!-- Filtro de Busca - CLIENTE COM TENDENCIA INATIVIDADE -->
      <template v-if="tipoSelecionado === 'clienteTendenciaInatividade'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="CNPJ">
            <b-input v-model="filtro.cnpj" placeholder="cnpj" v-mask="'##.###.###/####-##'"/>
          </b-field>

          <b-field label="Razão">
            <b-input v-model="filtro.razao" placeholder="razão social"/>
          </b-field>

          <b-field label="Fantasia">
            <b-input v-model="filtro.fantasia" placeholder="nome fantasia"/>
          </b-field>

          <label class="label">Primeira compra</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.primeiraCompraInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.primeiraCompraInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.primeiraCompraFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.primeiraCompraFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>

          <label class="label">Última compra</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.ultimaCompraInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.ultimaCompraInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.ultimaCompraFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.ultimaCompraFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>
        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>
        <b-tag class="is-medium is-primary" style="height: 100%">Total: {{lista.length}}</b-tag>
      </template>

      <!-- Filtro de Busca - PROSPECT -->
      <template v-if="tipoSelecionado === 'prospecto'" slot="menu">
        <portal-filtro-dropdown @filtrar="filtrar" @limpar="limparFiltro" :loading="loading">

          <b-field label="CNPJ">
            <b-input v-model="filtro.cnpj" placeholder="cnpj" v-mask="'##.###.###/####-##'"/>
          </b-field>

          <b-field label="Razão">
            <b-input v-model="filtro.razao" placeholder="razão social"/>
          </b-field>

          <b-field label="Fantasia">
            <b-input v-model="filtro.fantasia" placeholder="nome fantasia"/>
          </b-field>

          <label class="label">Data do cadastro</label>
          <b-field>
            <b-datepicker placeholder="De" v-model="filtro.cadastroInicio" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.cadastroInicio = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
            <b-datepicker placeholder="Até" v-model="filtro.cadastroFim" icon="today" :day-names="$dias()" :month-names="$meses()">
              <button class="button is-default"
                      @click.stop.prevent="filtro.cadastroFim = null">
                <b-icon icon="clear"></b-icon>
                <span>Limpar</span>
              </button>
            </b-datepicker>
          </b-field>
        </portal-filtro-dropdown>

        <button class="button is-light" :class="{'is-loading': loading}" @click="listar()">
          <b-icon icon="refresh" />
        </button>

        <b-tag class="is-medium is-primary" style="height: 100%">Total: {{lista.length}}</b-tag>
      </template>

      <lista-cliente :lista="lista" :loading="loading" v-if="tipoSelecionado === 'clienteAtivo'" :parametros="parametros"></lista-cliente>

      <lista-cliente-inativo :lista="lista" :loading="loading" v-if="tipoSelecionado === 'clienteInativo'" :parametros="parametros"></lista-cliente-inativo>

      <lista-cliente-tendencia :lista="lista" :loading="loading" v-if="tipoSelecionado === 'clienteTendenciaInatividade'" :parametros="parametros"></lista-cliente-tendencia>

      <lista-prospecto :lista="lista" :loading="loading" v-if="tipoSelecionado === 'prospecto'" :parametros="parametros"></lista-prospecto>

    </portal-box>
  </section>
</template>

<script>
  import { listagem } from '../../mixins/listagem'
  import {mask} from 'vue-the-mask'
  import ListaCliente from './ListaClienteAtivo'
  import ListaClienteInativo from './ListaClienteInativo'
  import ListaClienteTendencia from './ListaClienteTendencia'
  import ListaProspecto from './ListaProspecto'

  export default {
    directives: {mask},
    components: {ListaCliente, ListaClienteInativo, ListaClienteTendencia, ListaProspecto},
    mixins: [listagem],
    created () {
      this.url = this.$URL.CLIENTE.BASE
      this.metodo = 'PUT'
      this.tipoSelecionado = 'clienteAtivo'
      this.filtro.ativo_inativo = 'A'
    },
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/cliente/consulta').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
    },
    data () {
      return {
        tipoSelecionado: ''
      }
    },
    methods: {
      filtrarSelecionado () {
        if (this.tipoSelecionado === 'clienteAtivo') {
          this.filtro.ativo_inativo = 'A'
          this.url = this.$URL.CLIENTE.BASE
        } else if (this.tipoSelecionado === 'clienteInativo') {
          this.filtro.ativo_inativo = 'I'
          this.url = this.$URL.CLIENTE.BASE
        } else if (this.tipoSelecionado === 'clienteTendenciaInatividade') {
          this.filtro.ativo_inativo = 'T'
          this.url = this.$URL.CLIENTE.BASE
        } else {
          this.url = this.$URL.PROSPECT.BASE
        }
        this.filtrar()
      },
      limparFiltro () {
        this.filtro = {}
        if (this.tipoSelecionado === 'clienteAtivo') {
          this.filtro.ativo_inativo = 'A'
          this.url = this.$URL.CLIENTE.BASE
        } else if (this.tipoSelecionado === 'clienteInativo') {
          this.filtro.ativo_inativo = 'I'
          this.url = this.$URL.CLIENTE.BASE
        } else if (this.tipoSelecionado === 'clienteTendenciaInatividade') {
          this.filtro.ativo_inativo = 'T'
          this.url = this.$URL.CLIENTE.BASE
        } else {
          this.url = this.$URL.PROSPECT.BASE
        }
        this.filtrar()
      }
    },
    watch: {
      tipoSelecionado (value) {
        this.lista = []
        this.limparFiltro()
      }
    },
    computed: {
      parametros () {
        return this.$store.state.parametros
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/cliente/Lista.vue